import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'includesBy',
    standalone: false
})
export class IncludesByPipe implements PipeTransform {

  transform(array: any | string[] | undefined | null, value: any | string, key?: string): boolean {
    if (!array || !array.length) {
      return false;
    }
    return array.some(
      (element: any | string) => element && ((key ? (element as any)[key] : element) === value)
    );
  }

}
